import React, { useState, useEffect, Component, useRef, forwardRef } from "react";
import styled from "styled-components";
import background from "../../assets/meso-game-bg.png";
import PracticeGame from "../../components/PracticeGameAssessment";
import useTopicQuestions from "../../hooks/useTopicQuestions";
import useSpeech from "../../hooks/useSpeech";
import { debug } from "util";
import { render } from "react-dom";
//import style from './Geo.module.css';
import { Textfit } from 'react-textfit';

import style from '../../components/Geo.module.css';
import { Scale } from 'react-scaling';
//modes
import AsCalculator from "../../components/AsCalculator";
import AsCalculatorFraction from "../../components/AsCalculatorFraction";
import AsCalculatorFractionMixed from "../../components/AsCalculatorFractionMixed";

import axios from "axios";
import useAuth from "../../../auth/hooks/useAuth";

import next from "../../assets/maths_assessments/assets/Next.png";
import back from "../../assets/maths_assessments/assets/Back.png";
import blankbg from "../../assets/maths_assessments/assets/Blank.png";
import marks1 from "../../assets/maths_assessments/assets/marks1.png";

//Holds the current question with elements:
//question: question text
//answers: (correct: bool, value: answer string),
//correct: string of correct answer
var currQuestion;
var image;

//THESE VARIABLES NEED TO BE OUTSIDE THE EXPORT OTHERWISE THEY ARE SET TO DEFAULT EVERY FRAME
var questionNum = 0;
var useranswers = [];
var shuffledAnswers = [];

//Mixes up array
function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
}


export default function SummerAr({ ...props }) {
  const [loading, setLoading] = useState(true);
  const [correctQuestions, setCorrectQuestions] = useState([]);
  const [incorrectQuestions, setIncorrectQuestions] = useState([]);
  const [score, setScore] = useState(0);
  const [combo, setCombo] = useState(0);
  const [maxCombo, setMaxCombo] = useState(0);
  const [feedback, setFeedback] = useState([]);
  const { state: authState } = useAuth();
  const [gameOver, setGameOver] = useState(false);

  const [clearCalc, setClear] = useState(false);

  const [questions, setQuestions] = useState([]);

  //this.calculator = React.createRef();


  /*
  const { questions, status } = useTopicQuestions({
    topics: props.topics,
    game_type: props.gameType
  });*/
  const [currentQuestion, setCurrentQuestion] = useState([]);
  const [extraChars, setExtraChars] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [displayImage, setDisplayImage] = useState(false);

  const[showColouredFeedback, setColouredFeedback] = useState(false);
  const [waitTime, setWaitTime] = useState(2);

  const [status, setStatus] = useState(false);

  //0 = keypad, 
  //1 = multiple choice,
  // 2 = fraction,
  // 3 = int & frac

  //questions section
  var questionsYear2Length = [];
  questionsYear2Length.push({ "question" : "How long is the feather? ", "answer" : "8", "type": 0, "units" : "cm", "marks" : 1})
questionsYear2Length.push({ "question" : "How long is the book? ", "answer" : "14", "type": 0, "units" : "cm", "marks" : 1})
questionsYear2Length.push({ "question" : "Which is the tallest shape? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "Which is the shortest shape? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "What is the best unit of measurement for the height of a bag? ", "answer" : "Centimetres|Metres|Kilometres", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "What is the best unit of measurement for the height of a house? ", "answer" : "Metres|Centimetres|Kilometres", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "Which symbol makes the statement true?", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "Which symbol makes the statement true?", "answer" : "=|<|>", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "Which symbol makes the statement true?", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear2Length.push({ "question" : "Emile has 3 gems. The red gem is 5cm wide. The blue gem is 10cm wide. The green gem is wider than the red gem. The blue gem is wider then the green gem. How wide could the green gem be? ", "answer" : "8|11|4", "type": 1, "units" : "cm", "marks" : 1})


  
  

  var questionsYear2Measurement = [];
  questionsYear2Measurement.push({ "question" : "Which is heavier?", "answer" : "The red gem|The blue gem", "type": 4, "units" : "", "marks" : 1})
questionsYear2Measurement.push({ "question" : "Which is lighter? ", "answer" : "The green gem|The purple gem", "type": 4, "units" : "", "marks" : 1})
questionsYear2Measurement.push({ "question" : "What is the best unit of measurement for a drink?", "answer" : "Millilitres|Kilograms|Metres", "type": 1, "units" : "", "marks" : 1})
questionsYear2Measurement.push({ "question" : "What is the best unit of measurement for measuring the size of a book?", "answer" : "Centimetres|Litres|Kilograms", "type": 1, "units" : "", "marks" : 1})
questionsYear2Measurement.push({ "question" : "What is the best unit of measurement for weighing a chair? ", "answer" : "Kilograms|Litres|Metres", "type": 1, "units" : "", "marks" : 1})
questionsYear2Measurement.push({ "question" : "One gem weighs 100g. How much would two gems weigh?", "answer" : "200", "type": 0, "units" : "grams", "marks" : 1})
questionsYear2Measurement.push({ "question" : "One gem weighs 100g. How many gems would weigh 600g?", "answer" : "6", "type": 0, "units" : "gems", "marks" : 1})
questionsYear2Measurement.push({ "question" : "Emile's glass has 100ml of water. Aimee adds 50ml more water to  Emile's cup. How much water is in Emile's cup? ", "answer" : "150", "type": 0, "units" : "ml", "marks" : 1})
questionsYear2Measurement.push({ "question" : "How much water is in the beaker? ", "answer" : "80", "type": 0, "units" : "ml", "marks" : 1})
questionsYear2Measurement.push({ "question" : "How much does the chair weigh? ", "answer" : "20", "type": 0, "units" : "kg", "marks" : 1})
questionsYear2Measurement.push({ "question" : "Emile puts a gem on the chair. The gem weighs 2kg. How much does the chair and the gem weigh together? ", "answer" : "22", "type": 0, "units" : "kg", "marks" : 1})
questionsYear2Measurement.push({ "question" : "What is the temperature shown on the thermometer? ", "answer" : "24", "type": 0, "units" : "°", "marks" : 1})


  

  var questionsYear2Position = [];
  questionsYear2Position.push({ "question" : "Complete the sentence. The gem is ___ the rocket. ", "answer" : "above|below|to the right of ", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "Complete the sentence. The hat is ___ the gem. ", "answer" : "to the left of |to the right of |above", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "Complete the sentence. The feather is ___ the hat. ", "answer" : "below|above|to the right of ", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "Aimee starts in position A. After a quarter turn clockwise, which way will she be? ", "answer" : "B|C|D", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "Aimee now starts in postion B. If she makes a half turn, in which position will she be? ", "answer" : "D|C|A", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "What comes next in the pattern? ", "answer" : "A red triangle |A blue square|A blue triangle", "type": 1, "units" : "", "marks" : 1})
questionsYear2Position.push({ "question" : "What comes next in the pattern? ", "answer" : "An orange square|A blue rectangle|A green gem", "type": 1, "units" : "", "marks" : 1})


  
  
  var questionsYear2Time = [];
  questionsYear2Time.push({ "question" : "Which clock shows 4 o'clock?", "answer" : "D|B|C", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows half past 2? ", "answer" : "B|D|A", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows half past 3? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows 3 o'clock? ", "answer" : "A|D|C", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows quarter past 1?", "answer" : "E|F|G", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows quarter past 12? ", "answer" : "G|E|F", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which clock shows quarter to 1?", "answer" : "F|E|G", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which is the longest time? ", "answer" : "Half an hour|10 minutes|25 minutes", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which is the longest time? ", "answer" : "70 minutes|An hour|Half an hour", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Which is the shortest time? ", "answer" : "Five minutes|10 minutes|Quarter of an hour", "type": 1, "units" : "", "marks" : 1})
questionsYear2Time.push({ "question" : "Emile sets off at 2 o'clock. He arrives at quarter to 3. For how long did Emile travel?", "answer" : "45", "type": 0, "units" : "minutes", "marks" : 1})




  var questionsYear3Fractions = [];
  questionsYear3Fractions.push({ "question" : "Which shape has 1/8 shaded?", "answer" : "B|C|A", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Which shape has 1/2 shaded? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the equivalent fraction:", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "What is the value of A as shown on the number line? ", "answer" : "1/5|1/2|1/6", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "What is the value of B as shown on the number line? ", "answer" : "4/5|3/5|2/5", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the statement: ", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the statement: ", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the number sentence: ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the number sentence: ", "answer" : "3", "type": 0, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the part-whole model:", "answer" : "5/7", "type": 2, "units" : "", "marks" : 1})
questionsYear3Fractions.push({ "question" : "Complete the part-whole model:", "answer" : "5/11", "type": 2, "units" : "", "marks" : 1})



  var questionsYear3Measurements = [];
  questionsYear3Measurements.push({ "question" : "What is the best unit of measurement for measuring the size of a book?", "answer" : "Centimetres|Litres|Kilograms", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "What is the best unit of measurement for weighing a chair? ", "answer" : "Kilograms|Litres|Metres", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "How much does the red gem weigh?", "answer" : "220", "type": 0, "units" : "grams", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Each small blue gem weighs 10g. How much do 4 small blue gems weigh?", "answer" : "40", "type": 0, "units" : "grams", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Is 150g greater than, less than or the same as 1.50kg?", "answer" : "less than |greater than|same as", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Emile and Aimee each have some jet fuel. Together they have a total of 1 litre of jet fuel. How much jet fuel does Aimee have? ", "answer" : "400", "type": 0, "units" : "ml", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Complete the statement: ", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Complete the statement: ", "answer" : "=|>|<", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Complete the statement: ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear3Measurements.push({ "question" : "A blue gem weighs 10g. How much does 4 blue gems weigh?", "answer" : "40", "type": 0, "units" : "grams", "marks" : 1})
questionsYear3Measurements.push({ "question" : "Looking at the scales, what do 2 red gems weigh?", "answer" : "40", "type": 0, "units" : "grams", "marks" : 1})
questionsYear3Measurements.push({ "question" : "How much does 1 red gem weigh? ", "answer" : "20", "type": 0, "units" : "grams", "marks" : 1})

  

  var questionsYear3Shapes = [];
  questionsYear3Shapes.push({ "question" : "Which letter has right angles?", "answer" : "F|Z|U", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "Which letter has right angles?", "answer" : "E|W|S", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "What is the best unit of measurement for the height of a building? ", "answer" : "m|cm|mm", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "What is the best unit of measurement for the size of a book? ", "answer" : "cm|m|mm", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "What is the best unit of measurement for the thickness of a piece of card? ", "answer" : "mm|cm|km", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "Which angle is an acute angle?", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "Emile has turned clockwise. How much of a turn has Emile made? ", "answer" : "Three-quarters. |Half. |A quarter. ", "type": 1, "units" : "", "marks" : 1})
questionsYear3Shapes.push({ "question" : "How many faces does a cuboid have? ", "answer" : "6", "type": 0, "units" : "faces", "marks" : 1})
questionsYear3Shapes.push({ "question" : "How many edges does a triangular prism have? ", "answer" : "9", "type": 0, "units" : "edges", "marks" : 1})
questionsYear3Shapes.push({ "question" : "How many vertices does a cube have? ", "answer" : "8", "type": 0, "units" : "vertices", "marks" : 1})


  

  var questionsYear3Time = [];
  questionsYear3Time.push({ "question" : "How many minutes are there in one hour? ", "answer" : "60", "type": 0, "units" : "minutes", "marks" : 1})
questionsYear3Time.push({ "question" : "How many minutes are there in a quarter of an hour? ", "answer" : "15", "type": 0, "units" : "minutes", "marks" : 1})
questionsYear3Time.push({ "question" : "Which clock shows 4 o'clock? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Which clock shows half past 3? ", "answer" : "C|D|B", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Which clock shows quarter to 5?", "answer" : "D|C|A", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Complete the statement:", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Complete the statement:", "answer" : "<|>|=", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Complete the statement:", "answer" : "=|>|<", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Emile flies off at 10 minutes past 4. He flies for 20 minutes. What time does he land? ", "answer" : "30 minutes past 4. |20 minutes past 4.|10 minutes to 5", "type": 1, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Decide if the activity happened am or pm. Emile woke up in the morning. ", "answer" : "am|pm", "type": 4, "units" : "", "marks" : 1})
questionsYear3Time.push({ "question" : "Decide if the activity happened am or pm. Aimee went to Scrambler's home after school. ", "answer" : "pm|am", "type": 4, "units" : "", "marks" : 1})


  

  var questionsYear4Decimals = [];
  questionsYear4Decimals.push({ "question" : "Complete the part-whole models. What value should A be? ", "answer" : "0.6", "type": 0, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Complete the part-whole models. What value should B be? ", "answer" : "0.06", "type": 0, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "What is the number made on the place value grid? ", "answer" : "3.21", "type": 0, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Complete the statement using <, > or =. ", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Complete the statement using <, > or =. ", "answer" : "<|=|>", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Complete the statement using <, > or =. ", "answer" : ">|=|<", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Which fraction is equivalent to 0.2?", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Which fraction is equivalent to 0.5?", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Which fraction is equivalent to 0.02?", "answer" : "C|B|A", "type": 1, "units" : "", "marks" : 1})
questionsYear4Decimals.push({ "question" : "Emile uses 3/10 of his rocket fuel to take off and 1/10 of his rocket fuel to land. How much fuel does he have for the journey?", "answer" : "6/10|4/10|1/2", "type": 1, "units" : "", "marks" : 1})



  var questionsYear4Position = [];
  questionsYear4Position.push({ "question" : "What is the co-ordinate of point A?", "answer" : "(9,3)|(3,9)|(4,4)", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "What is the co-ordinate of point B?", "answer" : "(3,9)|(9,3)|(4,4)", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "What is the co-ordinate of point C?", "answer" : "(4,4)|(3,9)|(9,3)", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "What shape is made if points A, B and C are connected? ", "answer" : "A triangle|A square|An oblong", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "Point A is translated 3 squares left and 4 squares up. What is the co-ordinate of the new location of point A?", "answer" : "(6,7)|(12,3)|(12, 7)", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "Shape A has been translated to shape B. Shape A has been translated how many squares to the right or left? ", "answer" : "5", "type": 0, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "Shape A has been translated to shape B. Shape A has been translated up or down? ", "answer" : "Neither|Down|Up", "type": 1, "units" : "", "marks" : 1})
questionsYear4Position.push({ "question" : "By how many squares has Shape A has been translated up or down? ", "answer" : "0", "type": 0, "units" : "", "marks" : 1})

  


  var questionsYear4Shapes = [];
  questionsYear4Shapes.push({ "question" : "Of the three angles shown, which is the biggest angle? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Of the three angles shown, which is the smallest angle? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Of the three angles shown, which is the acute angle? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Of the three angles shown, which is the right angle? ", "answer" : "C|B|A", "type": 1, "units" : "", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Of the three angles shown, which is the obtuse angle? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "An isosceles triangles has at least how many sides the same length? ", "answer" : "2", "type": 0, "units" : "sides", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Scalene triangles have how many sides which are the same length? ", "answer" : "0", "type": 0, "units" : "sides", "marks" : 1})
  questionsYear4Shapes.push({ "question" : "Which shape is a trapezium? ", "answer" : "F|E|D", "type": 1, "units" : "", "marks" : 1})
  

  
  var questionsYear4Statistics = [];
  questionsYear4Statistics.push({ "question" : "The bar chart shows the number of gems found yesterday. How many red gems were found? ", "answer" : "22", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4Statistics.push({ "question" : "How many more blue gems than purple gems were found yesterday? ", "answer" : "13", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4Statistics.push({ "question" : "Here is a graph showing the temperature of a rocket engine when tested. What is the temperature of the rocket engine at 300 seconds?", "answer" : "2000", "type": 0, "units" : "°", "marks" : 1})
questionsYear4Statistics.push({ "question" : "How much does the rocket engine's temperature increase from 120 seconds to 240 seconds? ", "answer" : "3000", "type": 0, "units" : "°", "marks" : 1})
questionsYear4Statistics.push({ "question" : "What is the increase in engine temperature between 1 and 3 minutues? ", "answer" : "4000", "type": 0, "units" : "°", "marks" : 1})
questionsYear4Statistics.push({ "question" : "Here is a table showing the number and types of gems owned by Aimee, Emile and Scrambler. Who has the fewest red gems? ", "answer" : "Aimee|Scrambler|Emile", "type": 1, "units" : "", "marks" : 1})
questionsYear4Statistics.push({ "question" : "How many more green gems does Aimee have than Emile? ", "answer" : "3", "type": 0, "units" : "gems", "marks" : 1})
questionsYear4Statistics.push({ "question" : "How many gems does Aimee own?", "answer" : "32", "type": 0, "units" : "gems", "marks" : 1})


  var questionsYear4Time = [];
  questionsYear4Time.push({ "question" : "Which clock shows the time 17:00? ", "answer" : "A|B", "type": 4, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Which month has 31 days? ", "answer" : "March|June|September", "type": 1, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Which month has 28 or 29 days?", "answer" : "February|April|October", "type": 1, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Emile sets off at 10 past 2. He travels for 45 minutes. At what time does he arrive?", "answer" : "14:55|12:55|11:45", "type": 1, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Scrambler travels for half an hour. Who was traveling for a longer time? ", "answer" : "Emile|Scrambler", "type": 4, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Which clock shows the time 17 minutes to 4? ", "answer" : "C|D", "type": 4, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "How many hours are in a day? ", "answer" : "24", "type": 0, "units" : "hours", "marks" : 1})
questionsYear4Time.push({ "question" : "Which clocks shows 3.55pm? ", "answer" : "F|E|G", "type": 1, "units" : "", "marks" : 1})
questionsYear4Time.push({ "question" : "Aimee can do solve a maths question every 5 seconds. How many questions can she solve in 2 minutes? ", "answer" : "24", "type": 0, "units" : "questions", "marks" : 1})




  var questionsYear5Decimals = [];
  questionsYear5Decimals.push({ "question" : "What number is represented in the grid? ", "answer" : "0.354", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "What number is represented in the grid? ", "answer" : "0.321", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "0.267 + 0.331 =", "answer" : "0.598", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "What is the value of A? ", "answer" : "0.4", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "What is the value of B? ", "answer" : "0.94", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "Looking at the addition pyramid, what is the value of A?", "answer" : "3.23", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "Looking at the addition pyramid, what is the value of B?", "answer" : "6.63", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "Looking at the addition pyramid, what is the value of C?", "answer" : "16.06", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "0.72 x 10 =", "answer" : "7.2", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "0.72 x 100 =", "answer" : "72", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "0.72 ÷ 100 =", "answer" : "0.0072", "type": 0, "units" : "", "marks" : 1})
questionsYear5Decimals.push({ "question" : "Emile has £17.80. He buys a blue gem for £11.50 and a green gem for £3.55. How much money does he have left? ", "answer" : "2.75", "type": 0, "units" : "£", "marks" : 1})


  var questionsYear5Shapes = [];
  questionsYear5Shapes.push({ "question" : "Using the protractor overlaid on the angle, what is the size of the angle? ", "answer" : "140", "type": 0, "units" : "°", "marks" : 1})
questionsYear5Shapes.push({ "question" : "How many degrees are in a right angle? ", "answer" : "90", "type": 0, "units" : "°", "marks" : 1})
questionsYear5Shapes.push({ "question" : "Emile is facing north. He turns 145° clockwise. How many degrees does he need to turn clockwise to face north again?", "answer" : "215", "type": 0, "units" : "°", "marks" : 1})
questionsYear5Shapes.push({ "question" : "How many faces does a cuboid have? ", "answer" : "6", "type": 0, "units" : "faces", "marks" : 1})
questionsYear5Shapes.push({ "question" : "How many edges does a triangular prism have? ", "answer" : "9", "type": 0, "units" : "edges", "marks" : 1})
questionsYear5Shapes.push({ "question" : "How many vertices does a cube have? ", "answer" : "8", "type": 0, "units" : "vertices", "marks" : 1})
questionsYear5Shapes.push({ "question" : "What is the size of angle a°?", "answer" : "118", "type": 0, "units" : "°", "marks" : 1})
questionsYear5Shapes.push({ "question" : "What is the size of angle b°?", "answer" : "42", "type": 0, "units" : "°", "marks" : 1})
questionsYear5Shapes.push({ "question" : "Scrambler has drawn three pentagons. Which pentagon is a regular pentagon? ", "answer" : "A|B|C", "type": 1, "units" : "", "marks" : 1})

  

  var questionsYear5Units = [];
  questionsYear5Units.push({ "question" : "What is 1 litre in millilitres? ", "answer" : "1 litre = 1,000ml|1 litre = 100ml|1 litre = 10ml", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "120ml = how many litres? ", "answer" : "120ml = 0.12 litres|120ml = 1,200litres|120ml = 1.2litres", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "What is 1 metre in centimetres? ", "answer" : "1m = 100cm|1m = 1,000cm|1m = 10cm", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "What is 1 kilometre in metres? ", "answer" : "1km = 1,000m|1km = 10,000m|1km = 100m", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "What is 1 metre in millimetres? ", "answer" : "1m = 1,000mm|1m = 100mm|1m = 10mm", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "7cm = how many millimetres? ", "answer" : "70", "type": 0, "units" : "mm", "marks" : 1})
questionsYear5Units.push({ "question" : "1 inch is approximately 2.54cm. How many centimetres are in there approximately in 10 inches? ", "answer" : "25.4", "type": 0, "units" : "cm", "marks" : 1})
questionsYear5Units.push({ "question" : "1.5m + 200cm = ", "answer" : "1700", "type": 0, "units" : "mm", "marks" : 1})
questionsYear5Units.push({ "question" : "What is 1 kg in grams? ", "answer" : "1kg = 1,000g|1kg = 100g|1kg = 10g", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "4kg + 0.25kg + 250g = ", "answer" : "4.5", "type": 0, "units" : "kg", "marks" : 1})
questionsYear5Units.push({ "question" : "How many seconds are there in 1 minute?", "answer" : "60", "type": 0, "units" : "seconds", "marks" : 1})
questionsYear5Units.push({ "question" : "Complete the statement: ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "Complete the statement: ", "answer" : "=|>|<", "type": 1, "units" : "", "marks" : 1})
questionsYear5Units.push({ "question" : "Complete the statement: ", "answer" : ">|<|=", "type": 1, "units" : "", "marks" : 1})




  var questionsYear5Volume = [];
  questionsYear5Volume.push({ "question" : "How many cubes make up this 3d shape?", "answer" : "14", "type": 0, "units" : "cubes", "marks" : 1})
questionsYear5Volume.push({ "question" : "Emile has bought a present for Aimee. The present has measurements length 10cm, width 5cm and height 12cm. What is the volume of the present?", "answer" : "600", "type": 0, "units" : "cm³", "marks" : 1})
questionsYear5Volume.push({ "question" : "Emile is splitting up his 17 litres of rocket fuel into bottles. Each bottle can hold 2 litres of fuel. How many bottles does Emile need to store all 17 litres of fuel? ", "answer" : "9", "type": 0, "units" : "bottles", "marks" : 1})
questionsYear5Volume.push({ "question" : "Scrambler is also splitting up his rocket fuel into bottles. Scrambler has 25 litres, but only has 11 bottles each of which hold 2 litres. How many more bottles does Scrambler need to hold all his fuel?  ", "answer" : "2", "type": 0, "units" : "bottles", "marks" : 1})





  var questionsYear6Shapes = [];
  questionsYear6Shapes.push({ "question" : "Calculate the angle a°.", "answer" : "79", "type": 0, "units" : "°", "marks" : 1})
questionsYear6Shapes.push({ "question" : "Which angle is an acute angle?", "answer" : "A|B|D", "type": 1, "units" : "", "marks" : 1})
questionsYear6Shapes.push({ "question" : "Which angle is a right angle? ", "answer" : "C|A|B", "type": 1, "units" : "", "marks" : 1})
questionsYear6Shapes.push({ "question" : "Which angle is a reflex angle? ", "answer" : "B|A|D", "type": 1, "units" : "", "marks" : 1})
questionsYear6Shapes.push({ "question" : "Which shape does the net make when assembled - A, B or C? ", "answer" : "B|A|C", "type": 1, "units" : "", "marks" : 1})
questionsYear6Shapes.push({ "question" : "What is the angle a°?", "answer" : "42", "type": 0, "units" : "°", "marks" : 1})
questionsYear6Shapes.push({ "question" : "What is the angle b°?", "answer" : "44", "type": 0, "units" : "°", "marks" : 1})
questionsYear6Shapes.push({ "question" : "What is the angle c°?", "answer" : "49", "type": 0, "units" : "°", "marks" : 1})
questionsYear6Shapes.push({ "question" : "What is the angle d°?", "answer" : "82", "type": 0, "units" : "°", "marks" : 1})




  var questionsYear6Statistics = [];
  questionsYear6Statistics.push({ "question" : "Emile has been counting the number of rockets that fly past at different times. He has made a line graph. At what time did the fewest rockets fly passed? ", "answer" : "1:00|20:00|2:00", "type": 1, "units" : "", "marks" : 1})
questionsYear6Statistics.push({ "question" : "At what time did the most rockets fly past? ", "answer" : "9:00|12:00|1:00", "type": 1, "units" : "", "marks" : 1})
questionsYear6Statistics.push({ "question" : "What was the difference in the number of rockets that flew past between 16:00 and 17:00? ", "answer" : "5", "type": 0, "units" : "rockets", "marks" : 1})
questionsYear6Statistics.push({ "question" : "Aimee has recorded how many gems are used each day of a week. What is the mean number of gems used each day? ", "answer" : "5", "type": 0, "units" : "gems", "marks" : 1})
questionsYear6Statistics.push({ "question" : "On which day were the fewest number of gems used? ", "answer" : "Thursday|Monday|Sunday", "type": 1, "units" : "", "marks" : 1})
questionsYear6Statistics.push({ "question" : "Emile has 40 gems. The pie chart shows how many of each colour he has. What percentage of the gems are blue? ", "answer" : "25%|90%|50%", "type": 1, "units" : "", "marks" : 1})
questionsYear6Statistics.push({ "question" : "How many blue gems does Emile have? ", "answer" : "10", "type": 0, "units" : "gems", "marks" : 1})
questionsYear6Statistics.push({ "question" : "What percentage of Emile's gems are red? ", "answer" : "15%|40%|20%", "type": 1, "units" : "", "marks" : 1})


  

  var timer = -1;

//above is questions section
  
  console.log(props);

  if (status == false){
    currQuestion = [];
    console.log("STATUS IS FALSE");
    questionNum = 0;
    useranswers = [];
    shuffledAnswers = [];
    var query = props.assessment_type[0] + props.assessment_type[3];
    console.log("QUERY IS: " + query)
    //check what questions it is, checking year first will check terms later like summer etc
    if (query == "2length&height"){
      setQuestions(questionsYear2Length);
    } else if (query == "2measurements"){
      setQuestions(questionsYear2Measurement);
    }
    else if (query == "2position"){
      setQuestions(questionsYear2Position);
    }
    else if (query == "2time"){
      setQuestions(questionsYear2Time);
    }
    else if (query == "3fractions"){
      setQuestions(questionsYear3Fractions);
    }
    else if (query == "3measurements"){
      setQuestions(questionsYear3Measurements);
    }
    else if (query == "3shapes"){
      setQuestions(questionsYear3Shapes);
    }
    else if (query == "3time"){
      setQuestions(questionsYear3Time);
    }
    else if (query == "4decimals"){
      setQuestions(questionsYear4Decimals);
    }
    else if (query == "4position"){
      setQuestions(questionsYear4Position);
    }
    else if (query == "4shapes"){
      setQuestions(questionsYear4Shapes);
    }
    else if (query == "4statistics"){
      setQuestions(questionsYear4Statistics);
    }
    else if (query == "4time"){
      setQuestions(questionsYear4Time);
    }
    else if (query == "5decimals"){
      setQuestions(questionsYear5Decimals);
    }
    else if (query == "5shapes"){
      setQuestions(questionsYear5Shapes);
    }
    else if (query == "5units"){
      setQuestions(questionsYear5Units);
    }
    else if (query == "5volume"){
      setQuestions(questionsYear5Volume);
    }
    else if (query == "6shapes"){
      setQuestions(questionsYear6Shapes);
    }
    else if (query == "6statistics"){
      setQuestions(questionsYear6Statistics);
    }
    setStatus(true);
  }
  console.log(questions);

  if (useranswers.length == 0 && questions.length > 0){
    for (let i = 0; i < questions.length; i++) {
      useranswers.push("");
      shuffledAnswers.push("");
      //DO SHUFFLE QUESTIONS
      if (questions[i].type == 1){
        let choices = questions[i].answer.split("|");
        choices = shuffleArray(choices);
        shuffledAnswers[i] = choices;
      }
    }
    console.log("initial Answers array:")
    console.log(useranswers);
  }


  var questionMax = -1;
  if(props.minimum > 0)
  {
      questionMax = props.minimum;
  }

  function reduceTimer() {
    console.log(waitTime);
  setWaitTime(waitTime - 1);
  }

  console.log("question number: " + questionNum);

  /*TODO: 
  only submit at the end
  may need to scrap a lot of the core code and do it from the ground up
  create a new calculator class just for assessments
  the background image method needs to set it equal to currentquestion number

  */

  //Sets the question to a new one, currently no check for being the same question
  function newQuestion() {
    //questionNum++;
    currQuestion = questions[questionNum];
    console.log("Current question");
    console.log(currQuestion);
    console.log("Answers so far:");
    console.log(useranswers);
    setCurrentQuestion(currQuestion);
    setRefresh(!refresh);
    //CheckImage();
  }


  //Called on click
  async function checkResult(value, callback) {
    var isCorrect = true;
    if (value) {
      console.log(value.value + " " + currQuestion.correct);
      //correct answer
      if (currQuestion.correct === value.value) {
        setCorrectQuestions([...correctQuestions, currQuestion]);
        let multiplier = combo > 0 ? combo + 1 : 1;
        multiplier = multiplier > 5 ? 5 : multiplier;
        setScore(score + multiplier * 10);

        if (combo < 99) {
          setCombo(combo + 1);
        }
        if (combo > maxCombo) {
          setMaxCombo(combo);
        }

        newQuestion();
      }
      //incorrect answer
      else {
        isCorrect = false;
        setIncorrectQuestions([...incorrectQuestions, currQuestion]);
        if (combo === 0 && score >= 10) {
          setScore(score - 10);
        } else {
          setCombo(0);
        }

        let result = {
          question: currQuestion.question,
          correct: currQuestion.correct,
          incorrect: value.value
        };

        setFeedback([...feedback, result]);
        setColouredFeedback(true);
        setWaitTime(2);
      }
      //Generates a new question
      //newQuestion();

    }
  }

  useEffect(() => {
    if (waitTime > 0) {
        var waitttimerID = setInterval(() => reduceTimer(), 1000);
        return () => {
            clearInterval(waitttimerID);
        };
    } else {

        setColouredFeedback(false);
        newQuestion();
    }
  },[waitTime]);

  //Set the first question, called until questions are defined
  useEffect(() => {
    if (questions !== undefined) {
      console.log(questions);
      var sample = questions[questionNum];
      currQuestion = sample;
      setCurrentQuestion(currQuestion);
      //CheckImage();
    }
  }, [questions]);

  //No clue
  useEffect(() => {
    if (status !== undefined && status == true) {
      setLoading(false);
    }
  }, [status]);


  function QuestionImage() {
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return blankbg;
    }
    let requireString = "Block/";
    requireString+= props.assessment_type[0] + props.assessment_type[3] + (questionNum+1) + ".png";
    //requireString += "/question"+(questionNum+1)+".png";
    return (require("../../assets/maths_assessments/assets/"+requireString))
}

async function setAnswer(value)
  {
    console.log("SET VALUE");
    console.log(value);
    useranswers[questionNum] = value;
    console.log(useranswers);
  }

  function NavigationButtons(){
    if (questionNum != 0 && questionNum != questions.length){
      return (
        <div>
        <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>
        <NavigationButton
        onClick={() => nextQuestion()}>
          <NavigationText>
            Next
          </NavigationText>
        </NavigationButton>
        </div>
      );
    }else if (questionNum < questions.length){
      return (
      <div>
      <NavigationButton
      onClick={() => nextQuestion()}>
        <NavigationText>
          Next
        </NavigationText>
        
      </NavigationButton>
      </div>
      );
    }
    else{
      return (
        <div>
         <NavigationButtonBack
        onClick={() => previousQuestion()}>
          <NavigationTextBack>
            Back
          </NavigationTextBack>
        </NavigationButtonBack>

        <Button onClick={() => GameOver()} style={{fontSize: "3em", height: "100px", width: "300px", position: "relative", right: "-45%", textAlign: "center", lineHeight: "3.2"}}>
          Submit
        </Button>
        </div>
        );
    }
  }

  function GameOver(){
    setGameOver(true);//go to endscreen
  }

  function CompareIfCorrect(youranswer, question){
    if (question.type != 1){
      if (question.answer == youranswer){
        return true;
      }else{
        return false;
      }
    }else{
      let correct = question.answer.split("|")[0];
      if (youranswer == correct){
        return true;
      }else{
        return false;
      }
    }
  }

  //I moved this to be called from the practicegameassessment script so it is done on timeout and ending game
  async function SubmitAssessment(){
     let correct = 0;      
    let questionsAnswered = [];
    for (let i = 0; i < questions.length; i++) {
        if (CompareIfCorrect(useranswers[i], questions[i])){
          let data = {
            question: questions[i].question,
            correct: true,
            answer: useranswers[i]
        };
        correct++;
        questionsAnswered.push(data);
        }else{
          let data = {
            question: questions[i].question,
            correct: false,
            answer: useranswers[i]
        };
        questionsAnswered.push(data);
        }
      console.log(JSON.stringify(questionsAnswered));
    }

    let topicstats = [];
    let temptih = {
      topic_key : "mathsassessmentsub",
      game_key : "basic_mathments",
      num_asked : questionsAnswered.length,
      num_correct : correct,
      average_ans_time : "0.0"
    }
    topicstats.push(temptih);

    axios({
        url: `${process.env.REACT_APP_API}/submissions`,
        method: "post",
        headers: {
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Authorization": `Bearer ${authState.access_token}`
        },
        data: {
            "homework_id": props.homework.id,
            "topicstats": topicstats,
            "custom": null,
            "platform": "Assessment|" + "WEB" + "|" + process.env.REACT_APP_VERSION_NO,
            "game_id": props.homework.galaxy_id,
            "questionsAnswered": JSON.stringify(questionsAnswered)
        }
      }).then((response) => {
        setGameOver(true);//go to endscreen
      })
  }

  function SubmitTimeout(){
    SubmitAssessment();
  }

  
  async function nextQuestion(value)
  {
    questionNum++;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
    //setClear(true);
  }

  function ResetClear(){
    setClear(false);
  }

  async function previousQuestion(value)
  {
    questionNum--;
    //will haver to do something for when questionum == to the question list count to display the final submission page
    newQuestion();
  }

  //this returns a table that ticks what questions are done
   function GetEndTable(){
    var html = "";
    html+= "<div>"
    //create a table where it equals amount of questions
    html+= '<table style="margin-top: 20%; width:100%; border-collapse: collapse;">'
    html+= '<tr>'

    for (let i = 0; i < questions.length; i++) {
      console.log(i);
      html+= '<td style="height: 100px, text-align:center; font-size: 4em;">'
      html+= 'Q'+(i+1);
      html+= '</td>';
    }
    html+='</tr><tr>';
    
    useranswers.forEach(element => {
      if (element == ""){
        html+= '<td style="height: 100px; border: 1px solid #9999;"> </td>'
      }else{
        html+= '<td style="height: 100px; background: #FFA500; border: 1px solid #9999;"> </td>'
      }
    });
    html+= "</tr>";
    html+="</table>";
    html+= "</div>";

    return html;
  }

  //if the user presses a multichoice button
  function PressMulti(value) {
    useranswers[questionNum] = value;
    setRefresh(!refresh);
  }

  function MultichoiceButtons(){
    //var choices = currQuestion.answer.split("|");
    //choices = shuffleArray(choices);
    let choices = shuffledAnswers[questionNum];

    return (
    <div>
       {choices.map(answer => {
        if(useranswers[questionNum] == "" || answer != useranswers[questionNum]){
          return (
            <MButton
            {...console.log(answer)}
            value={<div dangerouslySetInnerHTML={answer} />}
            style={{ flex: 1, margin: "20px" }}
            onClick={() => PressMulti(answer)}
          >
              <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                  {answer}
                </Textfit>
              </div>
          </MButton>
         )}
        return (
          <MButtonSelected
          {...console.log("SELECTED")}
          value={<div dangerouslySetInnerHTML={answer} />}
          style={{ flex: 1, margin: "20px" }}
          onClick={() => PressMulti(answer)}
        >
            <div style={{ height: "80%", width: "100%" }}>
              <Textfit mode="multi" max="99" style={{ textShadow: "2px 2px 4px #000000", position: "relative", top: "24%", height: "90%" }}>
                {answer}
              </Textfit>
            </div>
        </MButtonSelected>
        )
      })}
    </div>
    )
  }

  function ShowMarks(){
    //IF QUESTION NUMBER GREATER THAN NUMBER OF QUESTIONS DISPLAY BLANK BACKGROUND
    if (questionNum >= questions.length){
      return "";
    }else{
      return marks1;
    }
  }

  //I don't know how to comment html/CSS
  return (
    <>
      <PracticeGame
        parent={props}
        gameOver={gameOver}
        SubmitMethod={() => SubmitTimeout()}
        correct={correctQuestions}
        incorrect={incorrectQuestions}
        score={score}
        defaultTimer={timer}
        questionNum={questionNum}
        questionNumMax ={questions.length}
        questionLimit={questionMax}
        onBack={() => props.onBack()}
        loading={loading}
        feedback={feedback}
        questionFontSize="0.7em"
        restart={() => {
          setCombo(0);
          setScore(0);
          setCorrectQuestions([]);
          setIncorrectQuestions([]);
        }}
      >
        <div id="scalinghere">
        <div style={{ backgroundImage: `url(${ShowMarks()}), url(${QuestionImage()})`, position: "relative", top: "-10%", height: "1400px", backgroundSize: "cover" }} >
            <Body>
              
              <div style={{ width: "80%" }}>
                {currQuestion != undefined ? (


                  <Container update={refresh}>

                    <div style={{ display: "flex", flexDirection: "row", alignSelf: "flex-end" }}>
                        <div style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "space-between"
                        }}>
                          {currQuestion.type == 0 &&
                            <AsCalculator
                            onChange={setAnswer}
                            fakeprop={true}
                            resetclear = {ResetClear}
                            currentQuestion={currQuestion}
                            currentAnswer={useranswers[questionNum]}
                            //ref={this.calculator}
                            />
                          }
                          {currQuestion.type == 1 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                            }
                {currQuestion.type == 2 &&
                 <AsCalculatorFraction
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                 {currQuestion.type == 3 &&
                 <AsCalculatorFractionMixed
                 onChange={setAnswer}
                 fakeprop={true}
                 resetclear = {ResetClear}
                 currentQuestion={currQuestion}
                 currentAnswer={useranswers[questionNum]}
                 //ref={this.calculator}
                 />

                }
                {currQuestion.type == 4 &&
                            <MultiChoiceContainer>
                            {MultichoiceButtons()}
                            </MultiChoiceContainer>
                }    
                        </div>
                    </div>
                    <NavigationContainer>
                    {NavigationButtons()}
                    </NavigationContainer>

                  </Container>

                ) : <div>
                <div dangerouslySetInnerHTML={{ __html: GetEndTable() }}>
                </div><NavigationContainer>{NavigationButtons()}</NavigationContainer></div> }
              </div>
            </Body>
            </div>
        </div>
      </PracticeGame>
    </>
  );
}

const MultiChoiceContainer = styled.div`
  position: relative;
  top: 50%;
  right: 20%;
`

const NavigationContainer = styled.div`
  position: fixed;
  top: 70%;
  right: 50%;
`

const Body = styled.div`
        width: 100%;
        height: 100%;
  background-image: url("");
        background-size: cover;
        background-position: 0px -1px;
        display: flex;
        justify-content: center;
        padding-top: 100px;
      `;

const Result = styled.div`
        width: 100%;
        height: 100%;
        font-size: 5em;
        text-align: center;
        border: solid 2px #683d8c;
      `;

const Combo = styled.div`
        background: #4391bb;
        width: 120px;
        height: 120px;
        border-radius: 75px;
        border: solid #204b7b 4px;
        display: flex;
        flex-direction: column;
        text-align: center;
        color: #fff;
        justify-content: center;
        font-weight: 600;
        margin-left: 50px;
      `;

const Marks = styled.div`
      font-size: 4em;
      position: relative;
      right: 33%;
      top: 73%;
    `;

const Container = styled.div`
      width:100%%;
      height:95%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding-bottom:100px;
      `;

const Question = styled.div`
      background: #FFF;
      user-select: none;
      width: 90%;
      height: 120px;
      line-height: 90px;
      font-size: 4em;
      margin: 15px 25px;
      text-align: center;
      font-weight: 600;
      border: none;
      border-radius: 10px;
    `;

const Button = styled.div`
    text-align: center;
    width: 20%;
    height: 150px;
    margin: 5px;
    color: #fff;
    user-select: none;
    background: rgb(234, 146, 19);
    background: linear-gradient(
      0deg,
      rgba(234, 146, 19, 1) 0%,
      rgba(255, 186, 32, 1) 100%
    );
    border: 2px solid #e88f12;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
  `;

  const MButton = styled.div`
    text-align: center;
    width: 350px;
    height: 150px;
    margin: 5px;
    color: #fff;

    background: linear-gradient(
      0deg,
      rgba(200, 200, 200, 1) 0%,
      rgba(225, 225, 225, 1) 100%
    );
    border: 2px solid #fff;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
      margin-bottom: 0;
    }
    user-select: none; /* supported by Chrome and Opera */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
  `;

  const MButtonSelected = styled.div`
  text-align: center;
  width: 350px;
  height: 150px;
  margin: 5px;
  color: #fff;
  background: linear-gradient(
    0deg,
    rgba(200, 200, 120, 1) 0%,
    rgba(225, 225, 100, 1) 100%
  );
  border: 2px solid #fff;
  box-sizing: border-box;
  border-radius: 0.25em;
  cursor: pointer;
  @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
    margin-bottom: 0;
  }
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
`;

const NavigationButton = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
right: -1000px;
top: 150px
background-image: url(${next});
color: #000;
user-select: none;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

const NavigationButtonBack = styled.div`
text-align: center;
width: 118px;
height: 144px;
margin: 5px;
position: absolute;
top: 150px;
right: 1000px
background-image: url(${back});
color: #000;
box-sizing: border-box;
border-radius: 0.25em;
cursor: pointer;
@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  margin-bottom: 0;
}
`;

  const NavigationText = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}
  `;

  const NavigationTextBack = styled.div`
  margin: 0;
  position: absolute;
  top: 50%;
  left: 60%;
  transform: translate(-50%, -50%);
  font-size: 25px;
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  `;

const ButtonImage = styled.img`
max-width: 80%;
max-height: 80%;
padding-top: 15px;
`